/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip, TextField } from '@mui/material'
import React from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import RadioBoxGroup from '../../../../components/RadioButtons/RadioBoxGroup'
const PaymentPage = () => {

    return (
        <>
            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                    <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                                    Process Payments
                                    <Tooltip title="When set to automatically, time is marked as 'paid' in our system and if you have payroll enabled, the payment will be sent." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Configure automated time off accrual rules</Typography>
                            </Box>
                            <Box>
                                <RadioBoxGroup
                                    options={['Manually', 'Automatically']}
                                    defaultValue="Manually"
                                    row={true}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                    Delay payroll
                                    <Tooltip title="This gives you time to edit timesheets once the pay period is over, or approve timesheets over multiple days and group all members into a single payment." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Establish a payroll delay to ensure all payments are processed simultaneously.</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                    Send payments after
                                    <Tooltip title="This is the number of days after the pay period ends that you would like to send payment for timesheets." arrow placement="top" alignContent="center">
                                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                            <InfoOutlineIcon fontSize="small" />
                                        </button>
                                    </Tooltip>
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <TextField type='text' placeholder='No of days' sx={{
                                    '& .MuiInputBase-formControl': {
                                        height: '44px', borderRadius: '8px'
                                    }
                                }} />
                                <Typography sx={{ color: '#1A1F36', fontSize: '14px' }}>Days</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', marginBottom: '30px' }}>
                            <Box>
                                <Button variant="contained" sx={{ boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #ddd', color: '#9095A1', textTransform: 'capitalize', background: 'none', marginRight: '10px', width: '80px' }} >
                                    Cancel</Button>
                                <Button variant="contained" sx={{ boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize', width: '80px' }} >
                                    Save</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

        </>
    )
}



export default PaymentPage
